module.exports = __webpack_public_path__ + "static/assets/c4fedf6d8022763dafa4432c2fe574aa.gif";